import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function LinkIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M6.66666 9.16697C6.95297 9.54972 7.31824 9.86642 7.7377 10.0956C8.15716 10.3248 8.621 10.461 9.09776 10.4952C9.57453
          10.5293 10.0531 10.4605 10.5009 10.2935C10.9487 10.1264 11.3554 9.86502 11.6933 9.52697L13.6933 7.52697C14.3005 6.8983
          14.6365 6.05629 14.6289 5.1823C14.6213 4.30831 14.2708 3.47227 13.6527 2.85424C13.0347 2.23621 12.1987 1.88565 11.3247
          1.87806C10.4507 1.87046 9.60867 2.20644 8.98 2.81364L7.83333 3.95364"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33334 7.83381C9.04704 7.45106 8.68177 7.13435 8.2623 6.90518C7.84284 6.67601 7.379 6.53973 6.90224 6.50559C6.42547
          6.47144 5.94695 6.54023 5.49911 6.70729C5.05127 6.87435 4.64459 7.13576 4.30667 7.47381L2.30667 9.47381C1.69948 10.1025
          1.3635 10.9445 1.37109 11.8185C1.37868 12.6925 1.72925 13.5285 2.34727 14.1465C2.9653 14.7646 3.80134 15.1151 4.67533
          15.1227C5.54932 15.1303 6.39133 14.7943 7.02 14.1871L8.16 13.0471"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}

export default LinkIcon;
